import { CSVLink } from 'react-csv';

import { Search } from 'lucide-react';
import { Col, DefaultSheet, FormGroup, Label, Row, DefaultTooltip, SheetBody } from 'twyne-new.ui';

import { getInfo } from '@Components/Grid/components/Table/formatters';
import { formatDateTime } from 'utils';

export default function DetailsEntity({ info }) {
  const { row } = getInfo(info)

  return <>
    <DefaultSheet
      trigger={<DefaultTooltip content='Details' side='left'> <Search size={16} /> </DefaultTooltip>}
      title='SCA Promotions Integration Details'
    >
      <SheetBody>
        <Row>
          {MODAL_COLUMNS.map(key => <ModalItem key={key} data={row} label={key} value={row[key] || '--'} />)}
        </Row>
      </SheetBody>
    </DefaultSheet>
  </>
}

function ModalItem({ label, value, data }) {
  if (['createdAt', 'updatedAt'].includes(label)) {
    value = formatDateTime(value)
  }

  if (label.startsWith('file.')) {
    if (label.endsWith('.content') && data.file && data.file.content) {
      value = <CSVLink data={data.file.content} filename={data.file.name}>
        Download
      </CSVLink>
    }

    if (label.endsWith('.*') && data.file) {
      value = <cite>
        <pre>
          {JSON.stringify(data.file, null, 2)}
        </pre>
      </cite>
    }
  }

  if (label === 'tickets' && Array.isArray(value)) {
    value = <CSVLink
      data={value.join('\n')}
      filename={`sweep${data.sweepId}-contest${data.contestId}.tickets.csv`}
    >
      Download
    </CSVLink>
  }

  return <Col size='6'>
    <FormGroup>
      <Label>{label}</Label>
      <div className='twy-text-base-accent'>{value}</div>
    </FormGroup>
  </Col>
}

const MODAL_COLUMNS = [
  'id',
  'contestId',
  'createdAt',
  'updatedAt',
  'sweepId',
  'integrationId',
  'status',
  'errorCode',
  'winnerFound',
  'winnerTicket',
  'ticketsCount',
  'tickets',
  'file.*',
  'file.content',
]
